import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticatedGuard} from '@core/guards/authenticated.guard';
import {IsOfflineGuard} from '@core/guards/is-offline.guard';
import {LoginComponent} from './features/login/login.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'prese-in-carico',
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'revisione53',
        loadChildren: () => import('./features/revisione53/revisione53.module').then((m) => m.Revisione53Module),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'prese-in-carico',
        loadChildren: () => import('./features/prese-in-carico/prese-in-carico.module').then((m) => m.PreseInCaricoModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'da-prendere-in-carico',
        loadChildren: () => import('./features/da-prendere-in-carico/da-prendere-in-carico.module').then((m) => m.DaPrendereInCaricoModule),
        canActivate: [AuthenticatedGuard],
    },
    {
        path: 'offline-upload',
        loadChildren: () => import('./features/offline-upload/offline-upload.module').then((m) => m.OfflineUploadModule),
        canActivate: [IsOfflineGuard],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
